
export const TECH_STACK_CATALOGUE = {
  frontend: [
    'JavaScript',
    'TypeScript',
    'React',
    'Next.js',
    'Vue',
    'Angular',
    'Svelte',
    'Blazor',
    'Razor Pages',
    'ASP.NET Core MVC'
  ],
  backend: [
    'Node',
    'Express',
    'NestJS',
    'Python',
    'Django',
    'FastAPI',
    'Java',
    'Spring Boot',
    'Go',
    'PHP/Laravel',
    'C#',
    'ASP.NET Core Web API'
  ],
  database: ['PostgreSQL', 'MySQL', 'MongoDB', 'SQLite', 'Redis', 'SQL Server']
} as const;

export type TechStackCategory = keyof typeof TECH_STACK_CATALOGUE;

export interface TechStack {
  frontend: string[];
  backend: string[];
  database: string[];
}

export function emptyTechStack(): TechStack {
  return { frontend: [], backend: [], database: [] };
}

export function techStackOrNull(stack: TechStack): TechStack | null {
  const empty = stack.frontend.length === 0 && stack.backend.length === 0 && stack.database.length === 0;
  return empty ? null : stack;
}
